import { useMutation } from "@tanstack/react-query";

import { _delete, deleteUser, reset } from "@/generated/api/users";

const useDeleteCompanyRelationMutation = () => {
  return useMutation({
    mutationFn: ({ userId }: { userId: number }) => deleteUser(userId),
    mutationKey: ["company"],
  });
};

const useResetUserMutation = () => {
  return useMutation({
    mutationFn: ({ ssoUserId }: { ssoUserId: string }) =>
      reset(encodeURIComponent(ssoUserId)),
  });
};

const useDeleteUserMutation = () => {
  return useMutation({
    mutationFn: ({ ssoUserId }: { ssoUserId: string }) =>
      _delete(encodeURIComponent(ssoUserId)),
    mutationKey: ["user"],
  });
};

export {
  useDeleteCompanyRelationMutation,
  useDeleteUserMutation,
  useResetUserMutation,
};
